import { mode } from '@chakra-ui/theme-tools';
const Card = {
  baseStyle: (props) => ({
    p: '20px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    borderRadius: '20px',
    minWidth: '0px',
    wordWrap: 'break-word',
    bg: mode('#ffffff', 'navy.800')(props),
    // Dark mode: thêm bóng đổ dịu + viền mảnh cho có chiều sâu (trước đây 'unset' -> phẳng).
    boxShadow: mode(
      '0 18px 40px -12px rgba(112, 144, 176, 0.18)',
      '0 18px 40px -16px rgba(0, 0, 0, 0.55)',
    )(props),
    border: mode('1px solid', '1px solid')(props),
    borderColor: mode('#EEEBF8', 'rgba(255,255,255,0.06)')(props),
    backgroundClip: 'border-box',
  }),
};

export const CardComponent = {
  components: {
    Card,
  },
};
